<template>
    <div>
        <label><b>Allegati</b></label>
        <table>
            <tr v-for="(file, index) in files">
                <input type="hidden" name="files[]" :value="file.id">
                <td>
                    <a :href="'/fascicoli/allegati/' + file.id" target="_blank">{{file.file_name}}</a>
                </td>
                <td>
                    <button @click="deleteRow(index)" type="button" class="btn"><i class="fas fa-trash"></i></button>
                </td>
            </tr>
        </table>
        <br>
        <input class="form-control"  type="file" :name="name" multiple>

    </div>
</template>
<script>
    export default {
        props:{
            value:{type:Array},
            name:{required:true}
        },
        data(){
            let allegati = [];
            let files = this.value;
            return {
                allegati,
                files,
                error:null,
                message:null,
                loading:false,
                validForm:false,
            };
        },
        methods: {
            deleteRow(index) {
                if(confirm("Confermi di voler cancellare l'allegato dal fascicolo?")) {
                        this.loading = true;
                        this.error = null;
                        this.message = null;

                        axios.delete("/fascicoli/alleagati/" + this.files[index].id + "/delete")
                            .then((response) => {
                                this.error = response.data.result !== "ok" ? "Non sei autorizzato a cancellare questo allegato" : null;
                                this.message = response.data.result === "ok" ? "Allegato cancellato con successo" : null;
                                if (response.data.result == "ok") {
                                    this.files.splice(index, 1);
                                }
                            })
                            .catch((error) => {
                                this.error = error;
                            })
                            .finally(() => {
                                this.loading = false;
                            }
                        );
                    }
            }
        },
    }
</script>
